export default __webpack_public_path__ + "static/bright-celebration-evening-sydney-34fb902f03655b96dc8c91751c39280b.jpg";